import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Roles } from "../../interface/Enums/Roles.enum";
import { useNavigate } from "react-router-dom";
import {
  BsGlobe2,
  BsStopwatch,
  BsBookmarkStar,
  BsFillDiagram2Fill,
  BsFillFileEarmarkPersonFill,
  BsFillPlusCircleFill,
  BsArrowBarRight,
  BsArrowBarLeft,
  BsFillPuzzleFill,
  BsChatDots,
  BsFillFlagFill,
  BsTable,
  BsFillPlusSquareFill,
  BsShieldFillCheck,
  BsBarChartFill,
  BsBarChart,
} from "react-icons/bs";
interface MenuState {
    authLevel: Roles;
}
const SalesForceMenu: React.FC<MenuState> = ({authLevel}) => {
  const navigate = useNavigate();
  return (
     <Nav variant="tabs" className="me-auto">
              {authLevel === Roles.SalesForceManager && (
                <>
                  <NavDropdown
                    title="Country Administrator"
                    id="basic-nav-dropdown"
                  >

                    <NavDropdown
                      title={`Global setup`}
                      drop="end"
                    >
                      <NavDropdown.Item
                      className="flex flex-row gap-2 align-items-center"
                        onClick={() => {
                          navigate("/admin-manage-jobname");
                        }}
                      >
                        <BsBookmarkStar color="orange" /> Manage Job Names
                      </NavDropdown.Item>

                      <NavDropdown.Item
                      className="flex flex-row gap-2 align-items-center"
                        onClick={() => {
                          navigate("/admin-manage-department");
                        }}
                      >
                        <BsFillDiagram2Fill color="orange" /> Manage Departments
                      </NavDropdown.Item>



                    </NavDropdown>
                    <NavDropdown.Item
                    className="flex flex-row gap-2 align-items-center"
                      onClick={() => {
                        navigate("/admin-manage-users");
                      }}
                    >
                        <BsFillFileEarmarkPersonFill color="green" /> Manage Users
                    </NavDropdown.Item>
                    <NavDropdown.Item
                    className="flex flex-row gap-2 align-items-center"
                      onClick={() => {
                        navigate("/admin/team-statistics");
                      }}
                    >
                        <BsBarChartFill color="green" /> Team Statistics
                    </NavDropdown.Item>
                    <NavDropdown.Item
                    className="flex flex-row gap-2 align-items-center"
                      onClick={() => {
                        navigate("/admin/team-assessment");
                      }}
                    >
                        <BsBarChart color="green" /> Team Assessment
                    </NavDropdown.Item>
                    <NavDropdown
                      title={"Appraisal Management"}
                      drop="end"
                    >

                      <NavDropdown.Item
                      className="flex flex-row gap-2 align-items-center"
                        onClick={() => {
                          navigate("/admin-manage-evaluation-periods");
                        }}
                      >
                        <BsStopwatch color="orange" /> Manage Evaluation Periods
                      </NavDropdown.Item>
                      <NavDropdown.Item
                      className="flex flex-row gap-2 align-items-center"
                        onClick={() => {
                          navigate("/admin-manage-performance-input-metrics");
                        }}
                      >
                        <BsArrowBarRight color="purple" /> Manage Inputs
                      </NavDropdown.Item>

                      <NavDropdown.Item
                      className="flex flex-row gap-2 align-items-center"
                        onClick={() => {
                          navigate("/admin-manage-performance-output-metrics");
                        }}
                      >
                        <BsArrowBarLeft color="purple" /> Manage Outputs
                      </NavDropdown.Item>

                      <NavDropdown.Item
                      className="flex flex-row gap-2 align-items-center"
                        onClick={() => {
                          navigate(
                            "/admin-manage-performance-competencies-metrics"
                          );
                        }}
                      >
                        <BsFillPuzzleFill color="purple" /> Manage Competencies
                      </NavDropdown.Item>

                      <NavDropdown.Item
                      className="flex flex-row gap-2 align-items-center"
                        onClick={() => {
                          navigate(
                            "/admin-manage-performance-comments-metrics"
                          );
                        }}
                      >
                        <BsChatDots color="purple" /> Manage Comments
                      </NavDropdown.Item>




                      <NavDropdown.Item
                      className="flex flex-row gap-2 align-items-center"
                        onClick={() => {
                          navigate("/admin-create-new-appraisal");
                        }}
                      >
                        <BsFillPlusCircleFill color="green" /> Create Appraisal
                      </NavDropdown.Item>
                    </NavDropdown>

                    <NavDropdown
                      title={"Annual Management"}
                      drop="end"
                    >
                      <NavDropdown.Item
                      className="flex flex-row gap-2 align-items-center"
                        onClick={() => {
                          navigate("/admin-annual-evaluation-summary");
                        }}
                      >
                        <BsGlobe2 color="orange" /> Evaluation Summary
                      </NavDropdown.Item>

                      <NavDropdown.Item
                      className="flex flex-row gap-2 align-items-center"
                        onClick={() => {
                          navigate("/admin-annual-evaluation-goals");
                        }}
                      >
                        <BsFillFlagFill color="orange" /> Future goals
                      </NavDropdown.Item>

                      <NavDropdown.Item
                      className="flex flex-row gap-2 align-items-center"
                        onClick={() => {
                          navigate("/admin-annual-evaluation-generic-table");
                        }}
                      >
                        <BsTable color="orange" /> Summary table
                      </NavDropdown.Item>

                      <NavDropdown.Item
                      className="flex flex-row gap-2 align-items-center"
                        onClick={() => {
                          navigate("/admin-annual-interview-career-expectations");
                        }}
                      >
                        <BsStopwatch color="orange" /> Interview - Carreer
                        Expectations
                      </NavDropdown.Item>

                      <NavDropdown.Item
                      className="flex flex-row gap-2 align-items-center"
                        onClick={() => {
                          navigate("/admin-annual-feedback-observations");
                        }}
                      >
                        <BsBookmarkStar color="orange" /> Observation & Feedback
                      </NavDropdown.Item>
                      <NavDropdown.Item
                      className="flex flex-row gap-2 align-items-center"
                        onClick={() => {
                          navigate("/admin-create-new-annual-evaluation");
                        }}
                      >
                        <BsFillPlusSquareFill color="green" /> Create Annual
                        Evaluation
                      </NavDropdown.Item>
                    </NavDropdown>
                    {/* BIDIRECTIONAL APPRAISAL MENU STARTS HERE */}
                    <NavDropdown
                      title={"Bidirectional Appraisal"}
                      drop="end"
                    >
                      <NavDropdown.Item
                      className="flex flex-row gap-2 align-items-center"
                        onClick={() => {
                          navigate("/admin/questions-create");
                        }}
                      >
                        {" "}
                        <BsGlobe2 color="orange" /> Questions Management
                      </NavDropdown.Item>

                     
                      <NavDropdown.Item
                      className="flex flex-row gap-2 align-items-center"
                        onClick={() => {
                          navigate("/admin/template-create");
                        }}
                      >
                        <BsFillPlusSquareFill color="green" /> Create Bidirectional Appraisal Template
                      </NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown  
                    title={"Energizer Management"}
                      drop="end">
                      <NavDropdown.Item 
                       className="flex flex-row gap-2 align-items-center"
                      onClick={() => {
                          navigate("/admin/energizer/create-standard-table");
                        }}>
                        <BsFillPlusSquareFill color="green" /> Standard Table(s)
                      </NavDropdown.Item>
                    </NavDropdown>

                    <NavDropdown.Item
                className="flex flex-row gap-2 align-items-center bg-warning text-white py-2"
                      onClick={() => {
                        navigate("/admin/udpates");
                      }}
                    >
                      <BsShieldFillCheck color="red" /> <small className="small">updates</small>
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      className="flex flex-row gap-2 align-items-center"
                      onClick={() => {
                        navigate("/admin/styled-components-showcase");
                      }}
                    >
                      <BsFillPuzzleFill color="purple" /> Styled Components Showcase
                    </NavDropdown.Item>
                  </NavDropdown>
                </>
              )}
            </Nav>
  );
};

export default SalesForceMenu;
